import { atom } from 'recoil';

export const LoadingState = atom<boolean>({
  key: 'global-loading', // unique ID
  default: false,
});
